import { UserI } from "global_state/state/UserState"

const UserReducer = (state: any, action:any) => {
    const { payload, type } = action
    // console.log("UserReducer".toUpperCase());
    
    // console.log(type);
    // console.log(payload);
    
    switch (type) {
        case "user_change" : {
            // console.log("user_change reducer".toUpperCase());
            // TODO: error - not show in the header component 
            let client_id: string | null = null
            let connection_id: string | null = null
            try {
                
                let xf_user: UserI = {
                    client_id: null,
                    connection_id: null
                }
                if ('xf_active_user' in sessionStorage) {
                    xf_user = JSON.parse(sessionStorage.getItem('xf_active_user') || "") as UserI
                    // console.log(xf_user);
                }
                
                client_id = xf_user?.client_id || null
                // console.log(client_id);   
                
                connection_id = xf_user?.connection_id || null
                // console.log(connection_id);

            } catch(error) {
                // console.log(error);
            }

            return {
                client_id : client_id,
                connection_id: connection_id
            }
        }
        case "log_out": {
            // console.log("USER REDUCER LOG OUT");
            
            sessionStorage.removeItem('xf_active_user');

            // console.log(state);
            let new_state = {
                client_id : null,
                connection_id: null
            }
            // console.log(new_state);
            
            return new_state
        }
        default: {
            return state
        }
    }   
}
export default UserReducer